'use client';

import React__default from 'react';
import { ELanguage } from '../Utils/constants.js';
import { Container } from './JobFunction.css.js';
import Cascader from '../Cascader/index.js';

var JobFunction = function (props) {
    var _a, _b, _c, _d, _e;
    var langCode = props.langCode, data = props.data, isMobile = props.isMobile, onChange = props.onChange, value = props.value, floatingConfig = props.floatingConfig, onBlur = props.onBlur, hasError = props.hasError, _f = props.isFlex, isFlex = _f === void 0 ? false : _f, _g = props.placeholderColor, placeholderColor = _g === void 0 ? '#999' : _g, _h = props.isSingleSelect, isSingleSelect = _h === void 0 ? false : _h, _j = props.displayAsPopup, displayAsPopup = _j === void 0 ? false : _j, _k = props.hiddenFooter, hiddenFooter = _k === void 0 ? false : _k, _l = props.textOptions, textOptions = _l === void 0 ? {
        placeholder: '',
        primaryBtnText: '',
        secondaryBtnText: ''
    } : _l, styleOptions = props.styleOptions, _m = props.msBaseUrl, msBaseUrl = _m === void 0 ? '' : _m, lockTarget = props.lockTarget, scrollLockMode = props.scrollLockMode, forResponsive = props.forResponsive, selectLayout = props.selectLayout;
    var optionsParent = data.parent.map(function (item) {
        return {
            id: item.id,
            name: langCode === ELanguage.VI ? item.name : item.nameEn
        };
    });
    return (React__default.createElement(Container, null,
        React__default.createElement(Cascader, { langCode: langCode, isMobile: isMobile, floatingConfig: floatingConfig !== null && floatingConfig !== void 0 ? floatingConfig : {}, value: value !== null && value !== void 0 ? value : [], options: {
                parent: optionsParent,
                children: data.child,
                jobCount: (_a = data.jobCount) !== null && _a !== void 0 ? _a : [],
                isEnableSearchAPI: true
            }, hasError: hasError !== null && hasError !== void 0 ? hasError : false, styleOptions: {
                isFlex: isFlex,
                placeholderColor: placeholderColor,
                isShowSecondaryBtn: (_b = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.isShowSecondaryBtn) !== null && _b !== void 0 ? _b : true,
                primaryBtnType: (_c = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.primaryBtnType) !== null && _c !== void 0 ? _c : 'primary',
                secondaryBtnType: (_d = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.secondaryBtnType) !== null && _d !== void 0 ? _d : 'default',
                clearSpaceLeft: (_e = styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.clearSpaceLeft) !== null && _e !== void 0 ? _e : false
            }, selectOptions: {
                isSingleSelect: isSingleSelect,
                displayAsPopup: displayAsPopup,
                hiddenFooter: hiddenFooter
            }, textOptions: textOptions, onConfirm: onChange, onCancel: function () { return onBlur && onBlur(); }, onBlur: function () { return onBlur && onBlur(); }, msBaseUrl: msBaseUrl !== null && msBaseUrl !== void 0 ? msBaseUrl : '', lockTarget: lockTarget, scrollLockMode: scrollLockMode, forResponsive: forResponsive, selectLayout: selectLayout })));
};

export { JobFunction as default };
//# sourceMappingURL=index.js.map
